<form>
  <h1 mat-dialog-title>{{'Accounts.addUserAccount.headerEdit' | translate}}</h1>
  <div class="container">
    <div mat-dialog-content>
      <div class="row">
        <mat-form-field class="col-6">
          <mat-label>{{'Accounts.addUserAccount.lblUsername' | translate}}</mat-label>
          <input type="text" matInput placeholder="{{'Accounts.addUserAccount.lblUsername' | translate}}" [(ngModel)]="userAccount.username" [ngModelOptions]="{standalone: true}" required readonly/>
        </mat-form-field>
        <mat-form-field class="col-6">
          <mat-label>{{'Accounts.addUserAccount.lblFirstName' | translate}}</mat-label>
          <input type="text" matInput placeholder="{{'Accounts.addUserAccount.lblFirstName' | translate}}" [(ngModel)]="userAccount.firstName" [ngModelOptions]="{standalone: true}"  required readonly/>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="col-6">
          <mat-label>{{'Accounts.addUserAccount.lblPassword' | translate}}</mat-label>
          <input type="text" matInput placeholder="{{'Accounts.addUserAccount.lblPassword' | translate}}" [(ngModel)]="userAccount.password" [ngModelOptions]="{standalone: true}" />
        </mat-form-field>
        <mat-form-field class="col-6">
          <mat-label>{{'Accounts.addUserAccount.lblLastName' | translate}}</mat-label>
          <input type="text" matInput placeholder="{{'Accounts.addUserAccount.lblLastName' | translate}}" [(ngModel)]="userAccount.lastName" [ngModelOptions]="{standalone: true}" required readonly/>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="col-6">
          <mat-label>{{'Accounts.addUserAccount.lblEmail' | translate}}</mat-label>
          <input type="email" matInput placeholder="{{'Accounts.addUserAccount.lblEmail' | translate}}" [(ngModel)]="userAccount.email" [ngModelOptions]="{standalone: true}" required readonly/>
        </mat-form-field>
        <mat-form-field class="col-6">
          <mat-label>{{'Accounts.addUserAccount.lblPhone' | translate}}</mat-label>
          <input type="text" matInput placeholder="{{'Accounts.addUserAccount.lblPhone' | translate}}" [(ngModel)]="userAccount.phone" [ngModelOptions]="{standalone: true}" required readonly/>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="col-6">
          <mat-label>{{'Accounts.addUserAccount.lblRole' | translate}}</mat-label>
          <input type="text" matInput [(ngModel)]="userAccount.roleName" [ngModelOptions]="{standalone: true}" readonly/>
        </mat-form-field>
        <mat-form-field class="col-6">
          <mat-label>{{'Accounts.addUserAccount.lblMobile' | translate}}</mat-label>
          <input type="text" matInput placeholder="{{'Accounts.addUserAccount.lblMobile' | translate}}" [(ngModel)]="userAccount.mobile" [ngModelOptions]="{standalone: true}" readonly/>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="col-6">
          <mat-label>{{'Accounts.addUserAccount.lblGenMarkets' | translate}}</mat-label>
          <mat-select multiple [(ngModel)]="userAccount.generalMarketIds" [ngModelOptions]="{standalone: true}" [disabled]="true">
            @for (market of markets; track market) {
              <mat-option [value]="market.id">{{market.value}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row">
        <div class="col-2">
          <mat-checkbox color="primary" [disabled]="true" [(ngModel)]="userAccount.enabled" [ngModelOptions]="{standalone: true}">{{'Accounts.ckbxEnabled' | translate}}</mat-checkbox>
        </div>
        <div class="col-2">
          <mat-slide-toggle color="primary" [disabled]="true" [(ngModel)]="userAccount.manager" [ngModelOptions]="{standalone: true}">{{'Accounts.addUserAccount.tglManager' | translate}}</mat-slide-toggle>
        </div>
        <div class="col-2">
          <mat-slide-toggle color="primary" [disabled]="true" [(ngModel)]="userAccount.readonly" [ngModelOptions]="{standalone: true}">{{'Accounts.addUserAccount.tglReadOnly' | translate}}</mat-slide-toggle>
        </div>
        <div class="col-3">
          <mat-checkbox color="primary" [disabled]="true" [(ngModel)]="userAccount.twoFactor" [ngModelOptions]="{standalone: true}">{{'Accounts.addUserAccount.ckbxTwoFactor' | translate}}</mat-checkbox>
        </div>
        <div class="col-3">
          <mat-checkbox color="primary" [disabled]="true" [(ngModel)]="userAccount.challenge" [ngModelOptions]="{standalone: true}">{{'Accounts.addUserAccount.ckbxChallenge' | translate}}</mat-checkbox>
        </div>
      </div>
      @if (userAccount.challenge) {
        <div [@slider]="userAccount.challenge? 'show' : null" class="slider">
          <div class="row">
            <mat-form-field class="col-6">
              <mat-label>{{'Accounts.addUserAccount.lblChallengeQu' | translate}}</mat-label>
              <input type="text" matInput placeholder="{{'Accounts.addUserAccount.lblChallengeQu' | translate}}" [(ngModel)]="userAccount.challengeQuestion" [ngModelOptions]="{standalone: true}" required readonly/>
            </mat-form-field>
            <mat-form-field class="col-6">
              <mat-label>{{'Accounts.addUserAccount.lblChallengeAnswer' | translate}}</mat-label>
              <input type="text" matInput placeholder="{{'Accounts.addUserAccount.lblChallengeAnswer' | translate}}" [(ngModel)]="userAccount.challengeAnswer" [ngModelOptions]="{standalone: true}" required readonly/>
            </mat-form-field>
          </div>
        </div>
      }
    </div>
    <div mat-dialog-actions class="mb-1">
      <button mat-raised-button color="primary" (click)="OnSaveAccount()">{{'btnSave' | translate}}</button>&nbsp;
      <button mat-raised-button color="secondary" (click)="OnCancel()">{{'btnCancel' | translate}}</button>
    </div>
  </div>
</form>
